module.exports = __webpack_public_path__ + "img/picto-petit-cochon-plus.387c1421.svg";